import React from 'react';
import application from '../../package.json';
import icon from '../assets/icon-80x80.png';
import logoInstagram from '../assets/logo-instagram.png';
import logoTFP from '../assets/logo-tfp.png';
import styles from './About.module.scss';
import useLocalize from '../hooks/use-localize';

const About = () => {
  const { localize } = useLocalize();

  return (
    <div className={styles.about}>
      <h1>{localize('about.app_name')}</h1>
      <div className={styles.version}>{localize('about.version', { version: application.version })}</div>
      <img className={styles.iconCupCake} src={icon} alt={localize('about.cup_cake.alt')} title={localize('about.cup_cake.title')} />
      <div className={styles.description}>{localize('about.description')}</div>
      <div className={styles.name}>
        <div>{localize('about.created_by')}</div>
        <a href='https://www.instagram.com/dr.bloche/' rel='noopener noreferrer' target='_blank'>
          <img className={styles.logoInstagram} src={logoInstagram} alt={localize('about.instagram.alt')} />
          <div className={`${styles.hint} ${styles.drBloche}`}>{localize('about.go_to_instagram')}</div>
        </a>
      </div>
      <div className={styles.name}>
        <div>{localize('about.for_tfp')}</div>
        <a href='https://thefrenchpatissier.com/' rel='noopener noreferrer' target='_blank' className={styles.closer}>
          <img className={styles.logoTFP} src={logoTFP} alt={localize('about.tfp.alt')} />
          <div className={`${styles.hint} ${styles.tfp}`}>{localize('about.go_to_tfp')}</div>
        </a>
      </div>
    </div>
  );
};

export default About;
